import { render, staticRenderFns } from "./NewsShow.vue?vue&type=template&id=2ebc3d72&scoped=true&"
import script from "./NewsShow.vue?vue&type=script&lang=js&"
export * from "./NewsShow.vue?vue&type=script&lang=js&"
import style0 from "./NewsShow.vue?vue&type=style&index=0&id=2ebc3d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc3d72",
  null
  
)

component.options.__file = "NewsShow.vue"
export default component.exports